var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonEditYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffecc9;}.b{fill:none;stroke:#f0a926;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28,
    height: 28,
    rx: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 10.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.424,21.546C12.311,21.4,9.759,18.1,6.5,18.1S.689,21.4.576,21.546a.359.359,0,0,0,0,.441c.114.147,2.665,3.446,5.924,3.446s5.811-3.3,5.924-3.434A.377.377,0,0,0,12.424,21.546Z",
    transform: "translate(-0.5 -18.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.839 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.36,29.5a2.16,2.16,0,1,0,2.16,2.16A2.16,2.16,0,0,0,31.36,29.5Z",
    transform: "translate(-29.2 -29.5)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEditYellow);
export default __webpack_public_path__ + "static/media/Button_Edit_Yellow.4173bbbb3c13045626335a08dab99956.svg";
export { ForwardRef as ReactComponent };